// extracted by mini-css-extract-plugin
export default {"button":"RequestForgottenPasswordEmail_button__hCSU0","space":"RequestForgottenPasswordEmail_space__RXrSk"};